// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__299lo","largestCol":"styles_largestCol__2kEnG","smallestCol":"styles_smallestCol__25zrN"};